export default __webpack_public_path__ + "static/media/home.3f9752a2.svg";